import * as React from "react";
const SvgBoxhubIconHakenNeg = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Ebene_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30", ...props }, /* @__PURE__ */ React.createElement("polygon", { fill: "#fff", points: "12.5 19.21 8.15 14.85 8.85 14.15 12.5 17.79 19.95 10.34 20.66 11.05 12.5 19.21" }));
export default SvgBoxhubIconHakenNeg;
